import React, { useEffect, useState } from "react"
import { useSelector } from "react-redux"
import { useHistory } from "react-router"
import moment from "moment"
import {
  addVital,
  dateCheck,
  raiseRmoApprovalRequest,
} from "../../core/services/api/patientDiagnosisService"
import { MocUserRole } from "../../core/services/models/Enums"
import Button from "../Button"
import InputField from "../InputField"
import DatePicker from "react-datepicker"
import "./VitalView.scss"
import Toast from "../../components/Toast"
import vitalUnit from "./vitalUnit.json"

export default function AddNewVitals({
  singleData,
  getAllVitalsData,
  handleClearClick,
  appointmentDetails,
  recordDetails,
  patientDetail,
  singleBpData,
  vitalIndex,
  userDetail,
  bpVitalArray,
  formVitalErrors,
  setFormVitalErrors,
  setBpVitalArray,
  isReadOnly,
  setVitalsArray,
  vitalsArray,
  deleteVitalBlock,
  isMandatoryFields,
  setMandatoryFields,
  validateVitals,
  setLoading,
  vitalsPayload,
  setVitalsPayload,
  beyondRange,
  beyondLimit,
  setBeyondRange,
  setBeyondLimit,
  setIsVitalSubmit,
  isVitalSubmit,
  setAllDetails,
  isAllDetails,
  isVitalData,
  setIsVitalData,
  isDataChanged,
  setIsDataChanged,
  setIsSavedAlready,
  isSavedAlready,
  emptyVitalsObj
}: any) {

  const userRole = useSelector((state: any) => state?.user?.role)
  const history = useHistory()
  const [datePickerIsOpen, toggleDatePicker] = useState<any>()
  const [displayToast, toggleDisplayToast] = useState<any>(false)
  const [dateToast, toggleDateToast] = useState<any>(false)
  const [deleteToast, toggleDeleteToast] = useState<any>(false)
  const [raiseRequest, setRaiseRequest] = useState(false)
  const centerId = appointmentDetails?.centerId
  const consultantId = appointmentDetails?.consultantId
  const appointmentId = appointmentDetails?.id
  const recordId = recordDetails?.id
  const patientId = appointmentDetails?.patientId

  const mandatoryFields = [
    "vitalCaptureDate"
  ]
  const ipdMandatoryFields = [
    "vitalCaptureDate"
  ]
  const vitalsReferenceRange: any = {
    Height: "140-205",
    Weight: "0-130",
    BSA: "0.17-2.7",
    BMI: "0.5-30.9",
    Temperature: "97-99",
    "BP Systolic": "90-140",
    "BP Diastolic": "60-90",
    Pulse: "60-100",
    SPO2: "92-100",
    Haemoglobin: "12-16",
    "Total WBC Count": "4000-11000",
    "Platelets Count": "150-400",
    "Absolute Neutrophil Count (ANC)": "1500-6000",
    "Total Bilirubin": "0.1-1.2",
    "Serum Bilirubin Direct": "0.1-0.4",
    "Serum Bilirubin Indirect": "0.2-0.8",
    "SGOT (AST)": "4-44",
    "ALT (SGPT)": "4-44",
    "Total Protein": "6.7-8.3",
    Albumin: "3.8-5",
    Globulin: "2.9-3.3",
    "AG Ratio": "1.3-2.5",
    "Alkaline Phosphatase": "33-111",
    GGT: "16-73",
    "Serum Creatinine": "0.6-1.10",
    BUN: "8-23",
    Urea: "15-40",
    "Uric Acid": "3-5.5",
    Sodium: "136-149",
    Potassium: "3.8-5.0",
    Chloride: "96-108",
    "S.Calcium": "8.4-10.2",
    LDH: "106-211",
    "eGFR- Creat Clearance": "60-130",
    "HGT-mg/dl": "80-140",
  }


  const calculateBmiAndBsa = () => {
    if (!(vitalsArray?.[vitalIndex]?.Height === "0" && vitalsArray?.[vitalIndex]?.Weight === "0")) {
      if (
        !(isNaN(Number(vitalsArray?.[vitalIndex]?.Height)) && isNaN(Number(vitalsArray?.[vitalIndex]?.Weight)))
      ) {
        let bmi =
          Number(vitalsArray?.[vitalIndex]?.Weight) /
          Math.pow(Number(vitalsArray?.[vitalIndex]?.Height) / 100, 2)

        bmi = isNaN(bmi) ? 0 : Math.round((bmi + Number.EPSILON) * 100) / 100
        const tempBSA =
          (Number(vitalsArray?.[vitalIndex]?.Height) * Number(vitalsArray?.[vitalIndex]?.Weight)) / 3600
        let bsa = Math.sqrt(tempBSA)
        bsa = Math.round((bsa + Number.EPSILON) * 100) / 100
        const tempVitalData = [...vitalsArray]
        tempVitalData[vitalIndex] = {
          ...vitalsArray?.[vitalIndex],
          BMI: bmi.toString(),
          BSA: bsa.toString(),
        }
        setVitalsArray(tempVitalData)
      }
    }
  }

  const calculateCreatClearance = () => {
    if ((vitalsArray?.[vitalIndex]?.Weight !== "" && vitalsArray?.[vitalIndex]?.["Serum Creatinine"] !== "" && patientDetail?.age !== 0)) {
      if ((Number(vitalsArray?.[vitalIndex]?.Weight) !== 0 && Number(vitalsArray?.[vitalIndex]?.["Serum Creatinine"]) !== 0 && Number(patientDetail?.age) !== 0)) {
        let creatClearance =
          ((140 - Number(patientDetail?.age)) * (Number(vitalsArray?.[vitalIndex]?.Weight))) / (72 * Number(vitalsArray?.[vitalIndex]?.["Serum Creatinine"]))
        let finalCreatClearance
        let temp = Math.round(creatClearance)
        if (patientDetail?.gender === "Male") {
          finalCreatClearance = temp
        } else {
          finalCreatClearance = Math.round(Number(temp) * 0.85)
        }
        const tempVitalData = [...vitalsArray]
        tempVitalData[vitalIndex] = {
          ...vitalsArray?.[vitalIndex],
          "eGFR- Creat Clearance": finalCreatClearance.toString(),
        }
        setVitalsArray(tempVitalData)
      }
    }
  }

  useEffect(() => {
    calculateBmiAndBsa()
  }, [vitalsArray?.[vitalIndex]?.Height, vitalsArray?.[vitalIndex]?.Weight])

  useEffect(() => {
    calculateCreatClearance()
  }, [vitalsArray?.[vitalIndex]?.Weight, vitalsArray?.[vitalIndex]?.["Serum Creatinine"], patientDetail?.age])

  const saveCheck = (tempError: any, tempSubmit: any) => {
    if (
      tempError?.[vitalIndex]?.color &&
      Object.keys(tempError?.[vitalIndex]?.color).length > 0 &&
      tempSubmit?.[vitalIndex]
    ) {
      let tempVitalPyload = [...vitalsPayload]
      tempVitalPyload[vitalIndex] = {
        VitalsData: vitalsArray?.[vitalIndex],
        VitalsBp: bpVitalArray?.[vitalIndex],
        errors: formVitalErrors?.[vitalIndex],
      }
      setVitalsPayload(tempVitalPyload)

      if (
        userRole === MocUserRole.CONSULTANT
      ) {
        const tempLimit = [...beyondLimit]
        tempLimit[vitalIndex] = true
        setBeyondLimit(tempLimit)
      } else {
        const tempRange = [...beyondRange]
        tempRange[vitalIndex] = true
        setBeyondRange(tempRange)
      }
      const tempSubmit1 = [...isVitalSubmit]
      tempSubmit1[vitalIndex] = false
      setIsVitalSubmit(tempSubmit1)
    } else if (
      tempError?.[vitalIndex]?.bold &&
      Object.keys(tempError?.[vitalIndex]?.bold).length > 0 &&
      tempSubmit?.[vitalIndex]
    ) {
      let tempVitalPyload1 = [...vitalsPayload]
      tempVitalPyload1[vitalIndex] = {
        VitalsData: vitalsArray?.[vitalIndex],
        VitalsBp: bpVitalArray?.[vitalIndex],
      }
      setVitalsPayload(tempVitalPyload1)

      const tempLimit = [...beyondLimit]
      tempLimit[vitalIndex] = true
      setBeyondLimit(tempLimit)

      const tempSubmit1 = [...isVitalSubmit]
      tempSubmit1[vitalIndex] = false
      setIsVitalSubmit(tempSubmit1)
    } else if (
      Object.keys(tempError?.[vitalIndex]?.bold).length === 0 &&
      Object.keys(tempError?.[vitalIndex]?.color).length === 0 &&
      tempSubmit?.[vitalIndex]
    ) {
      const tempObj = { ...vitalsArray?.[vitalIndex] }
      delete tempObj.BSA
      delete tempObj.BMI
      delete tempObj.BP
      const values = Object.entries(tempObj)
      const bool = values.some((v: any) => v[1] == "")

      if (bool) {
        let tempVitalPyload2 = [...vitalsPayload]
        tempVitalPyload2[vitalIndex] = {
          VitalsData: vitalsArray?.[vitalIndex],
          VitalsBp: bpVitalArray?.[vitalIndex],
        }
        setVitalsPayload(tempVitalPyload2)

        const tempallDetail = [...isAllDetails]
        tempallDetail[vitalIndex] = true
        setAllDetails(tempallDetail)
      } else {
        let tempVitalPyload2 = [...vitalsPayload]
        tempVitalPyload2[vitalIndex] = {
          VitalsData: vitalsArray?.[vitalIndex],
          VitalsBp: bpVitalArray?.[vitalIndex],
        }
        setVitalsPayload(tempVitalPyload2)
        addVital(
          {
            ...vitalsArray?.[vitalIndex],
            previousVitalCaptureDate: vitalsArray?.[vitalIndex]?.["previousVitalCaptureDate"] ? vitalsArray?.[vitalIndex]?.["previousVitalCaptureDate"] : vitalsArray?.[vitalIndex]?.["vitalCaptureDate"],
            vitalCaptureDate: vitalsArray?.[vitalIndex]?.["vitalCaptureDate"],
            bpSystolic: bpVitalArray?.[vitalIndex]?.["BP Systolic"],
            bpDiastolic: bpVitalArray?.[vitalIndex]?.["BP Diastolic"],
          },
          { centerId, consultantId, patientId, appointmentId, recordId }
        )
          .then((data) => {
            setLoading(false)
            getAllVitalsData(recordDetails?.id)
            const tempData = [...isVitalData]
            tempData[vitalIndex] = true
            setIsVitalData(tempData)

            const tempChange = [...isDataChanged]
            tempChange[vitalIndex] = false
            setIsDataChanged(tempChange)

            const tempSavedAlready = [...isSavedAlready]
            tempSavedAlready[vitalIndex] = true
            setIsSavedAlready(tempSavedAlready)

            toggleDisplayToast({
              text: `Vitals for date: ${moment(vitalsArray[vitalIndex]?.vitalCaptureDate)?.format("DD-MM-YYYY")} saved successfully`,
              type: "success",
            })
          })
          .catch((err) => {
            setLoading(false)
            console.log(err)
          })
      }
    }
  }

  const handleVitalsSave = () => {
    addVital(
      {
        ...vitalsArray?.[vitalIndex],
        previousVitalCaptureDate: vitalsArray?.[vitalIndex]?.["previousVitalCaptureDate"] ? vitalsArray?.[vitalIndex]?.["previousVitalCaptureDate"] : vitalsArray?.[vitalIndex]?.["vitalCaptureDate"],
        vitalCaptureDate: vitalsArray?.[vitalIndex]?.["vitalCaptureDate"],
        bpSystolic: bpVitalArray?.[vitalIndex]?.["BP Systolic"],
        bpDiastolic: bpVitalArray?.[vitalIndex]?.["BP Diastolic"],
      },
      { centerId, consultantId, patientId, appointmentId, recordId }
    )
      .then((data: any) => {
        const tempLimit = [...beyondLimit]
        tempLimit[vitalIndex] = false
        setBeyondLimit(tempLimit)

        const tempData = [...isVitalData]
        tempData[vitalIndex] = true
        setIsVitalData(tempData)

        const tempDetails = [...isAllDetails]
        tempDetails[vitalIndex] = false
        setAllDetails(tempDetails)

        const tempSubmit1 = [...isVitalSubmit]
        tempSubmit1[vitalIndex] = false
        setIsVitalSubmit(tempSubmit1)

        const tempChange = [...isDataChanged]
        tempChange[vitalIndex] = false
        setIsDataChanged(tempChange)

        const tempSavedAlready = [...isSavedAlready]
        tempSavedAlready[vitalIndex] = true
        setIsSavedAlready(tempSavedAlready)

        getAllVitalsData(recordDetails?.id)

        toggleDisplayToast({
          text: `Vitals for date: ${moment(vitalsArray[vitalIndex]?.vitalCaptureDate)?.format("DD-MM-YYYY")} saved successfully`,
          type: "success",
        })

      })
      .catch((err: any) => {
        toggleDisplayToast({
          text: `${err?.response?.data?.message ? err?.response?.data?.message : "Something went wrong, Please try again later."}`,
          type: "error",
        })
        console.log(err)
      })
  }

  const handleVitalSubmit = (e: any) => {
    if (userRole !== MocUserRole.FRONT_DESK) {

      const tempSubmit = [...isVitalSubmit]
      tempSubmit[vitalIndex] = true
      setIsVitalSubmit(tempSubmit)

      const tempError = [...formVitalErrors]
      tempError[vitalIndex] = validateVitals(vitalsArray?.[vitalIndex], bpVitalArray, vitalIndex)
      setFormVitalErrors(tempError)

      saveCheck(tempError, tempSubmit)
    }
  }

  const saveSelectedDate = (date: any) => {
    const tempVital = [...vitalsArray]
    tempVital[vitalIndex]["vitalCaptureDate"] = date
    setVitalsArray(tempVital)

    const tempChange = [...isDataChanged]
    tempChange[vitalIndex] = true
    setIsDataChanged(tempChange)
  }

  const handleDateSelected = (date: any, index: any) => {
    const ChangeArray = isDataChanged?.map((value: any, index: any) => (value ? index : null))?.filter((value: any) => value !== null);

    if (ChangeArray?.length > 0 && index !== vitalIndex) {
      toggleDisplayToast({
        text: `Please save vitals for date: ${ChangeArray.map((i: any) => moment(vitalsArray[i]?.vitalCaptureDate)?.format("DD-MM-YYYY")).join(", ")}  to continue adding vitals for additional dates`,
        type: "error",
      });
    } else {
      let temp = moment(date).format("YYYY-MM-DD")
      toggleDatePicker(!datePickerIsOpen)
      dateCheck(temp, recordId)
        .then((res: any) => {
          if (res?.data === true) {
            toggleDateToast({
              text: "Vitals for this date already exists",
              type: "warning",
              date: temp
            })
          } else {
            saveSelectedDate(temp)
          }
        })
        .catch((err: any) => {
          console.error(err)
          toggleDisplayToast({
            text: `${err?.response?.data?.message ? err?.response?.data?.message : "Something went wrong, Please try again later."}`,
            type: "error",
          })
        })
    }
  }


  function validate() {
    const res = validateVitals(singleData, bpVitalArray, vitalIndex)
    const tempFormVitalErrors = [...formVitalErrors]
    tempFormVitalErrors[vitalIndex] = res
    setFormVitalErrors(tempFormVitalErrors)
  }

  const handleRaiseRequest = () => {
    let queryStr = "The following vitals exceed the range: "
    Object.keys(vitalsPayload?.[vitalIndex]?.errors?.color).forEach((ele: any, index: any) => {
      if (index === Object.keys(vitalsPayload?.[vitalIndex]?.errors?.color)?.length - 1) {
        queryStr += `${ele}:${ele === "BP Systolic" ? vitalsPayload?.[vitalIndex]?.VitalsBp["BP Systolic"] : ele === "BP Diastolic" ? vitalsPayload?.[vitalIndex]?.VitalsBp["BP Diastolic"] : vitalsPayload?.[vitalIndex]?.VitalsData[ele]}(${ele === "BP Systolic" ? vitalsReferenceRange["BP Systolic"] : ele === "BP Diastolic" ? vitalsReferenceRange["BP Diastolic"] : vitalsReferenceRange[ele]}).`;
      } else {
        queryStr += `${ele}:${ele === "BP Systolic" ? vitalsPayload?.[vitalIndex]?.VitalsBp["BP Systolic"] : ele === "BP Diastolic" ? vitalsPayload?.[vitalIndex]?.VitalsBp["BP Diastolic"] : vitalsPayload?.[vitalIndex]?.VitalsData[ele]}(${ele === "BP Systolic" ? vitalsReferenceRange["BP Systolic"] : ele === "BP Diastolic" ? vitalsReferenceRange["BP Diastolic"] : vitalsReferenceRange[ele]}), `;
      }

    })
    raiseRmoApprovalRequest({
      rmoId: userDetail?.id,
      vitalCaptureDate: singleData?.["vitalCaptureDate"],
      appointmentDate: appointmentDetails?.scheduleDate,
      consultantId: consultantId,
      patientId: patientId,
      recordId: recordId,
      centerId: centerId,
      approvalFor: queryStr,
      reason: "",
      isExtraVitalsReq: true
    })
      .then((data: any) => {
        const tempRange = [...beyondRange]
        tempRange[vitalIndex] = false
        setBeyondRange(tempRange)

        const tempChange = [...isDataChanged]
        tempChange[vitalIndex] = false
        setIsDataChanged(tempChange)

        //To save vitals after raise request
        handleVitalsRaiseRequest()
      })
      .catch((err: any) => {
        console.log(err)
      })
  }

  const handleVitalsRaiseRequest = () => {
    addVital(
      {
        ...vitalsPayload?.[vitalIndex]?.VitalsData,
        previousVitalCaptureDate: vitalsArray?.[vitalIndex]?.["previousVitalCaptureDate"] ? vitalsArray?.[vitalIndex]?.["previousVitalCaptureDate"] : vitalsArray?.[vitalIndex]?.["vitalCaptureDate"],
        vitalCaptureDate: vitalsArray?.[vitalIndex]?.["vitalCaptureDate"],
        bpSystolic: vitalsPayload?.[vitalIndex]?.VitalsBp["BP Systolic"],
        bpDiastolic: vitalsPayload?.[vitalIndex]?.VitalsBp["BP Diastolic"],
      },
      { centerId, consultantId, patientId, appointmentId, recordId }
    )
      .then((data: any) => {
        const tempLimit = [...beyondLimit]
        tempLimit[vitalIndex] = false
        setBeyondLimit(tempLimit)
        getAllVitalsData(recordDetails?.id)
        setRaiseRequest(true)

        const tempChange = [...isDataChanged]
        tempChange[vitalIndex] = false
        setIsDataChanged(tempChange)

        const tempSavedAlready = [...isSavedAlready]
        tempSavedAlready[vitalIndex] = true
        setIsSavedAlready(tempSavedAlready)

      })
      .catch((err: any) => {
        console.log(err)
        toggleDisplayToast({
          text: `${err?.response?.data?.message ? err?.response?.data?.message : "Something went wrong, Please try again later."}`,
          type: "error",
        })
      })
  }


  return (
    <>
      {
        isVitalData[vitalIndex] && vitalsArray?.[vitalIndex]?.id ? (
          <Toast
            textMessage={` Vital Data added Successfully`}
            type="success"
            onCloseText={"Close"}
            onClickText={"Appointments"}
            onClose={() => {
              const tempData = [...isVitalData]
              tempData[vitalIndex] = false
              setIsVitalData(tempData)
            }}
            onClick={() => history.push("/calendar")}></Toast>
        ) : beyondRange?.[vitalIndex] ? (
          <Toast
            textMessage={`One or more fields exceed beyond range, Do you want to proceed further`}
            type="warning"
            onCloseText={"Close"}
            onClickText={"Raise Request"}
            onClose={() => {
              const tempRange = [...beyondRange]
              tempRange[vitalIndex] = false
              setBeyondRange(tempRange)
            }}
            onClick={handleRaiseRequest}>
          </Toast>
        ) : beyondLimit?.[vitalIndex] ? (
          <Toast
            textMessage={`One or more fields exceed beyond limit, Do you want to proceed further`}
            type="error"
            onCloseText={"Close"}
            onClickText={"Save Anyways"}
            onClose={() => {
              const tempLimit = [...beyondLimit]
              tempLimit[vitalIndex] = false
              setBeyondLimit(tempLimit)
            }}
            onClick={handleVitalsSave}></Toast>
        ) : isAllDetails?.[vitalIndex] === true ? (
          <Toast
            textMessage={`You have not entered all test details. Do you want to proceed further?`}
            type="warning"
            onCloseText={"Close"}
            onClickText={"Save Anyways"}
            onClose={() => {
              const tempDetails = [...isAllDetails]
              tempDetails[vitalIndex] = false
              setAllDetails(tempDetails)
            }}
            onClick={() => {
              handleVitalsSave()
            }}></Toast>
        ) : raiseRequest ? (
          <Toast
            textMessage={`Request Raised Successfully`}
            type="success"
            onCloseText={"Close"}
            onClickText={"Appointments"}
            onClose={() => setRaiseRequest(false)}
            onClick={() => history.push("/calendar")}></Toast>
        ) : displayToast ? (
          <Toast
            textMessage={displayToast?.text}
            type={displayToast?.type}
            onClose={() => toggleDisplayToast(false)}
            onCloseText="Close"
            onClickText={null}
          />
        ) : dateToast ? (
          <Toast
            textMessage={dateToast?.text}
            type={dateToast?.type}
            onClose={() => toggleDateToast(false)}
            onCloseText="Close"
            onClickText="Continue"
            onClick={() => {
              saveSelectedDate(dateToast?.date); toggleDateToast(false)
            }}
          />
        ) : deleteToast ? (
          <Toast
            textMessage={deleteToast?.text}
            type={deleteToast?.type}
            onClose={() => toggleDeleteToast(false)}
            onCloseText="No"
            onClickText="Yes"
            onClick={() => {
              deleteVitalBlock(vitalIndex, singleData?.vitalCaptureDate); toggleDeleteToast(false)
            }}
          />
        ) : null
      }
      <div>
        <div className="vital-header">
          <div className="current-date">
            <img
              className={isReadOnly ? "vital-date cursor-not-allowed" : " vital-date cursor-pointer "}
              onClick={() => {
                if (!isReadOnly) {
                  toggleDatePicker(!datePickerIsOpen)
                }
              }}
              src="../../assets/images/datepickerIcon.svg"
              alt=""
              height={30}
              width={30}
            />
            {datePickerIsOpen && (
              <DatePicker
                selected={
                  appointmentDetails?.scheduleDate
                    ? new Date(new Date(appointmentDetails.scheduleDate).setDate(new Date(appointmentDetails.scheduleDate).getDate() - 1))
                    : new Date(new Date().setDate(new Date().getDate() - 1))
                }
                onChange={(date: Date) => handleDateSelected(date, vitalIndex)}
                onClickOutside={() => toggleDatePicker(false)}
                maxDate={
                  appointmentDetails?.scheduleDate
                    ? new Date(new Date(appointmentDetails?.scheduleDate).setDate(new Date(appointmentDetails?.scheduleDate).getDate() - 1))
                    : new Date()
                }
                inline
              />
            )}
            <div>{singleData?.vitalCaptureDate ? moment(singleData?.vitalCaptureDate)?.format("DD-MM-YYYY") : <span className="date-placeholder">Select date</span>}</div>
          </div>
          {!isReadOnly && (
            <div className='cursor-pointer delete-icon' onClick={() => {
              if (isSavedAlready?.[vitalIndex] && singleData?.vitalCaptureDate) {
                toggleDeleteToast({
                  text: `Are you sure you want to delete vitals added for ${moment(vitalsArray[vitalIndex]?.vitalCaptureDate)?.format("DD-MM-YYYY")}?`,
                  type: "warning",
                })
              } else {
                deleteVitalBlock(vitalIndex, null)
              }
            }}>
              <img src="../../assets/images/delete-icon-new.svg" alt="" height={"32px"} width={"32px"} />
            </div>
          )}
        </div>
        <div className="vital-content">
          <div className="vital-row row">

            {Object.keys(emptyVitalsObj)?.filter((key) => key !== "vitalCaptureDate")?.map((item: any, i) => {
              const isIPD: any = appointmentDetails?.appointmentType === "IPD"
              const value: string = singleData?.[item]
              return (
                <><div className="col-3 col-md-3 mb-4">
                  <div className="label label_margin">{`${isIPD ? ipdMandatoryFields?.includes(item) ? "*" : "" : mandatoryFields?.includes(item) ? "*" : ""} ${item}`}:</div>
                  {item === "BP" ? (
                    <div className="smaller-input">
                      <InputField
                        value={singleBpData?.["BP Systolic"]}
                        handleChange={(e) => {
                          const tempBpArray = [...bpVitalArray]
                          tempBpArray[vitalIndex] = { 'BP Systolic': e.target.value, 'BP Diastolic': singleBpData["BP Diastolic"] }
                          setBpVitalArray(tempBpArray)

                          const tempChange = [...isDataChanged]
                          tempChange[vitalIndex] = true
                          setIsDataChanged(tempChange)
                        }}
                        readOnly={isReadOnly || singleData?.["vitalCaptureDate"] === ""}
                        className={formVitalErrors?.[vitalIndex]?.color && formVitalErrors?.[vitalIndex]?.color[item && "BP Systolic"]
                          ? "red-text"
                          : formVitalErrors?.[vitalIndex]?.bold && formVitalErrors?.[vitalIndex]?.bold[item && "BP Systolic"]
                            ? "bold-text"
                            : ""}
                        handleBlur={() => {
                          (userRole !== MocUserRole.FRONT_DESK && !isReadOnly) &&
                            validate()
                        }

                        }
                      />
                      /
                      <InputField
                        value={singleBpData?.["BP Diastolic"]}
                        handleChange={(e) => {
                          const tempBpArray = [...bpVitalArray]
                          tempBpArray[vitalIndex] = { 'BP Systolic': singleBpData["BP Systolic"], 'BP Diastolic': e.target.value }
                          setBpVitalArray(tempBpArray)

                          const tempChange = [...isDataChanged]
                          tempChange[vitalIndex] = true
                          setIsDataChanged(tempChange)
                        }}
                        readOnly={isReadOnly || singleData?.["vitalCaptureDate"] === ""}
                        className={formVitalErrors?.[vitalIndex]?.color && formVitalErrors?.[vitalIndex]?.color[item && "BP Diastolic"]
                          ? "red-text"
                          : formVitalErrors?.[vitalIndex]?.bold && formVitalErrors?.[vitalIndex]?.bold[item && "BP Diastolic"]
                            ? "bold-text"
                            : ""}
                        handleBlur={() => {
                          (userRole !== MocUserRole.FRONT_DESK && !isReadOnly) &&
                            validate()
                        }

                        }
                      />
                    </div>
                  ) : (
                    <div>
                      <InputField
                        value={value}
                        handleChange={(e) => {
                          const tempVital = [...vitalsArray]
                          tempVital[vitalIndex][item] = e.target.value
                          setVitalsArray(tempVital)

                          const tempChange = [...isDataChanged]
                          tempChange[vitalIndex] = true
                          setIsDataChanged(tempChange)
                        }}
                        readOnly={(item === "BSA" || item === "BMI" || item === "eGFR- Creat Clearance" ? true : false) ||
                          isReadOnly || singleData?.["vitalCaptureDate"] === ""}
                        className={formVitalErrors?.[vitalIndex]?.color && formVitalErrors?.[vitalIndex]?.color[item]
                          ? "red-text"
                          : formVitalErrors?.[vitalIndex]?.bold && formVitalErrors?.[vitalIndex]?.bold[item]
                            ? "bold-text"
                            : ""}
                        handleBlur={() => {
                          (userRole !== MocUserRole.FRONT_DESK && !isReadOnly) &&
                            validate()
                        }
                        }
                      />
                    </div>
                  )}
                </div><div className="col-1 units">&nbsp;{vitalUnit[i]}</div></>
              )
            })}
          </div>
          <div className="save-clear">
            {isSavedAlready[vitalIndex] === false && (
              <div className="vital-submit">
                {isReadOnly ? "" : <Button outline={true} text="Clear" type={"button"} onClick={() => handleClearClick(vitalIndex)} ></Button>}
              </div>
            )}
            <div className="vital-submit">
              {isReadOnly ? "" : <Button text="Save Vitals" id="save-vitals" disabled={singleData?.["vitalCaptureDate"] === ""} type={"button"} onClick={handleVitalSubmit}></Button>}
            </div>
          </div>
        </div>
      </div >
      {/* </form > */}
    </>
  )
}
